import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormService} from "../form.service";
import {FormGroup} from "@angular/forms";
import {ApiServiceService} from "../../../../../Services/api-service.service";
import {Router} from "@angular/router";
import * as querystring from "node:querystring";

@Component({
  selector: 'app-information-preview',
  templateUrl: './information-preview.component.html',
  styleUrls: ['./information-preview.component.css']
})
export class InformationPreviewComponent {

  form:FormGroup;

  screenHeight = window.screen.height - 271; // 1058
  minHeight = 'min-height: ' + this.screenHeight + 'px !important'

  screenHeight2 = window.screen.height - 630; // 428
  minHeight2 = 'min-height: ' + this.screenHeight2 + 'px !important'
  saving: boolean = false;
   isLoading: boolean;
   message: any;
   ASIN_No: any;

  constructor(private formService:FormService, private apiService:ApiServiceService, private router:Router) {
    this.form = formService.getForm();
    console.log(this.form)
  }


  cancel() {
    this.formService.sendMessage(2)
  }
  next(){
    this.formService.sendMessage(4)
  }

  submitForm() {
    this.saving = true;
    const data  = {
      "password": this.formService.businessDetailsGroup.get("password")?.value,
      "email": this.formService.businessDetailsGroup.get("email")?.value,
      "phoneNumber": this.formService.businessDetailsGroup.get("phone")?.value,
      "corporateName": this.formService.businessDetailsGroup.get("business_name")?.value,
      "businessCategory": this.formService.businessInformationGroup.get("businessCategory")?.value.split('-')[0],
      "numberOfEmployees": this.formService.businessInformationGroup.get("numberOfEmployees")?.value,
      "numberOfBranches": this.formService.businessInformationGroup.get("numberOfBranches")?.value,
      "webAddress": this.formService.businessInformationGroup.get("webAddress")?.value,
      "dateOfCommencement": this.formService.businessInformationGroup.get("dateOfCommencement")?.value,
      "businessAddress": this.formService.businessInformationGroup.get("businessAddress")?.value,
      "businessState": this.formService.businessInformationGroup.get("businessState")?.value.split('-')[0],
      "businessLga": this.formService.businessInformationGroup.get("businessLga")?.value.split('-')[0],
      "businessArea": this.formService.businessInformationGroup.get("businessArea")?.value.split('-')[0],
      "businessContactFirstName": this.formService.businessInformationGroup.get("businessContactFirstName")?.value,
      "businessContactLastName": this.formService.businessInformationGroup.get("businessContactLastName")?.value,
      "businessContactEmail": this.formService.businessInformationGroup.get("businessContactEmail")?.value,
      "businessContactPhoneNumber": this.formService.businessInformationGroup.get("businessContactPhoneNumber")?.value,
      "businessContactPosition": this.formService.businessInformationGroup.get("businessContactPosition")?.value,
      "businessContactAddress": this.formService.businessInformationGroup.get("businessContactAddress")?.value,
      "isBusinessAddressRented": this.formService.businessInformationGroup.get("isBusinessAddressRented")?.value,
      "landLordName": this.formService.businessInformationGroup.get("landLordName")?.value,
      "landLordPhoneNumber": this.formService.businessInformationGroup.get("landLordPhoneNumber")?.value,
      "landLordAddress": this.formService.businessInformationGroup.get("landLordAddress")?.value,
      "rcNumber": this.formService.businessInformationGroup.get("rcNumber")?.value,
      "dateOfIncorporation": this.formService.businessInformationGroup.get("dateOfIncorporation")?.value,
      "businessType": this.formService.businessInformationGroup.get("businessType")?.value == "" ? null : this.formService.businessDetailsGroup.get("businessType")?.value,
      "solelyOnline": this.formService.businessInformationGroup.get("solelyOnline")?.value,
      "hasVehicle": this.formService.businessInformationGroup.get("hasVehicle")?.value,
      "vehicleCount": this.formService.businessInformationGroup.get("vehicleCount")?.value,
      "hasCorporateProperty": this.formService.businessInformationGroup.get("hasCorporateProperty")?.value,
      "corporatePropertyCount": this.formService.businessInformationGroup.get("corporatePropertyCount")?.value,
      "hasCorporateAsset": this.formService.businessInformationGroup.get("hasCorporateAsset")?.value,
      "corporateAssetCount": this.formService.businessInformationGroup.get("corporateAssetCount")?.value,
      "jtbTin": this.formService.businessInformationGroup.get("jtbTin")?.value,
      "tin": this.formService.businessDetailsGroup.get("tin")?.value,
      "entityType": this.formService.businessDetailsGroup.get("entityType")?.value
    }

    console.log(data)
    // this.isLoading = true
    // return;
    this.apiService.loginPost_('/auth/enumeration/company/save', data).subscribe(res => {
      this.isLoading = false;
      this.message = res.message;
      if (res.success){
        this.router.navigate(['create-asin/success/'+res.data.asin],{queryParams: {type:"COMPANY"}})
        this.ASIN_No = res.data.asin
        this.next()
      }
    })
  }
}
